<template>
    <div class="content">
        <pageTool></pageTool>
        <Header
            :page-title="title"
        ></Header>
        <div class="page-content" v-if="title.cn == '订单农业'">
            <div class="page-title">
                <span>订单信息</span>
            </div>
            <div class="page-img">
                <a-carousel :after-change="onChange" autoplay>
                    <div v-for="(img, i) in title.list" :key="i"><img :src="title.internalInstance.appContext.config.globalProperties.$imgUrl + img"></div>
                </a-carousel>
            </div>
            <div class="page-text">
                <p>{{ title.info.title }}</p>
                <p>订单品种：{{ title.info.type }}</p>
                <p>订单价格：{{ title.info.price }} {{ title.info.company }}</p>
                <p>订单数量：{{ title.info.count }}</p>
                <p>订单日期：{{ title.info.effectiveTime }} ~ {{ title.info.failureTime }}</p>
                <p>订单区域：{{ title.info.address }}</p>
                <p>订单主体：{{ title.info.publisher }}</p>
                <div class="page-text-button">
                    <a-button type="primary" class="cus-button">
                        <a :href="'tel:' + title.info.phone">立即联系</a>
                    </a-button>
                </div>
            </div>
        </div>
        <div class="page-content" v-else-if="title.cn == '托管服务'">
            <div class="page-title">
                <span>托管信息</span>
            </div>
            <div class="page-img">
                <a-carousel :after-change="onChange" autoplay>
                    <div v-for="(img, i) in title.list" :key="i"><img :src="title.internalInstance.appContext.config.globalProperties.$imgUrl + img"></div>
                </a-carousel>
            </div>
            <div class="page-text">
                <p>{{ title.info.title }}</p>
                <p>需求类型：{{ title.info.type }}</p>
                <p>需求预算：{{ title.info.price }} {{ title.info.company }}</p>
                <p>需求数量：{{ title.info.count }}</p>
                <p>需求日期：{{ title.info.effectiveTime }} ~ {{ title.info.failureTime }}</p>
                <p>需求区域：{{ title.info.address }}</p>
                <p>发布人：{{ title.info.publisher }}</p>
                <div class="page-text-button">
                    <a-button type="primary" class="cus-button">
                        <a :href="'tel:' + title.info.phone">立即联系</a>
                    </a-button>
                </div>
            </div>
            <div class="page-title">
                <span>我要托管</span>
            </div>
            <div class="page-text page-text-block">
                <p style="margin-bottom: 20px">托管信息</p>
                <a-form :model="TGForm" :label-col="labelCol" :wrapper-col="wrapperCol">
                    <a-form-item label="托管数量">
                        <a-input-number v-model:value="TGForm.count"/>
                    </a-form-item>
                    <a-form-item label="起始日期">
                        <a-date-picker
                            v-model:value="TGForm.effectiveTime"
                            show-time
                            type="date"
                            placeholder="起始日期"
                            style="width: 100%"
                        />
                    </a-form-item>
                    <a-form-item label="结束日期">
                        <a-date-picker
                            v-model:value="TGForm.failureTime"
                            show-time
                            type="date"
                            placeholder="结束日期"
                            style="width: 100%"
                        />
                    </a-form-item>
                    <a-form-item label="姓名">
                        <a-input v-model:value="TGForm.name"/>
                    </a-form-item>
                    <a-form-item label="联系电话">
                        <a-input v-model:value="TGForm.phone"/>
                    </a-form-item>
                    <a-form-item label="身份证号">
                        <a-input v-model:value="TGForm.idCard"/>
                    </a-form-item>
                    <a-form-item label="所在区域">
                        <a-input v-model:value="TGForm.address"/>
                    </a-form-item>
                </a-form>
                <div class="page-text-button">
                    <a-button type="primary" class="cus-button">提交</a-button>
                </div>
            </div>
        </div>
        <div class="page-content" v-else>
            <div class="page-img">
                <a-carousel :after-change="onChange" autoplay>
                    <div v-for="(img, i) in title.list" :key="i"><img :src="title.internalInstance.appContext.config.globalProperties.$imgUrl + img"></div>
                </a-carousel>
            </div>
            <div class="page-text">
                <p>{{ title.info.title }}</p>
<!--                <p>类型：{{ title.info.type }}</p>-->
<!--                <p>价格：{{ title.info.price }} {{ title.info.company }}</p>-->
                <p>日期：{{ title.info.effectiveTime }} ~ {{ title.info.failureTime }}</p>
                <p>区域：{{ title.info.address }}</p>
                <p>联系人：{{ title.info.contacts }}</p>
                <p>主体：{{ title.info.publisher }}</p>
                <p>详情：{{ title.info.msg }}</p>
                <div class="page-text-button">
                    <a-button type="primary" class="cus-button">
                        <a :href="'tel:' + title.info.phone">立即联系</a>
                    </a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "@/components/SNInfo/Header"
import {onMounted, reactive, getCurrentInstance} from "@vue/runtime-dom"
import pageTool from "@/components/nav/pageTool"
import {useRoute} from "vue-router"
import {getOrderDetailApi, getOrderType} from '@/api/order'
import {getDemandType, getPriceCompanyType, getDemandDetail} from "@/api/demand"
import {getServiceDetailApi, getTrustTypeApi} from '@/api/trust'
import { getServiceType, getServiceDetail} from "@/api/service"
const banner = require('@/assets/img/page_banner_1.png')
export default {
    name: "Details",
    setup() {
        const route = useRoute()
        const title = reactive({
            cn: '',
            en: '',
            hasSearch: false,
            titleStyle: false,
            banner,
            list: [],
            id: [],
            internalInstance: getCurrentInstance(),
            info: {}
        })
        const TGForm = reactive({
            count: '',
            effectiveTime: undefined,
            failureTime: undefined,
            name: '',
            phone: '',
            idCard: '',
            address: ''
        })
        let priceRes = reactive({})
        let orderType = reactive({})
        let serviceType = reactive({})
        const getDDDomInfo = async () => {
            priceRes = await getPriceCompanyType()
            orderType = await getOrderType()
        }
        const getTGDomInfo = async () => {
            priceRes = await getPriceCompanyType()
            serviceType = await getTrustTypeApi()
        }
        const onChange = () => {
            // console.log(current);
        }
        const initData = async (id) => {
            if (title.cn == '订单农业') {
                await getDDDomInfo()
                const data = await getOrderDetailApi(id)
                title.info = data.order
                title.list = data.order.imgs ? data.order.imgs.split(',') : ''
                title.info.company = priceRes[title.info.company]
                title.info.type = orderType[title.info.type]
            } else if (title.cn == '托管服务') {
                await getTGDomInfo()
                const data = await getServiceDetailApi(id)
                title.info = data.trust
                title.list = data.trust.imgs ? data.trust.imgs.split(',') : ''
                title.info.company = priceRes[title.info.company]
                title.info.type = serviceType[title.info.type]
            } else if (title.cn == '服务信息') {
                await getDDDomInfo()
                let type
                getServiceType().then(res => {
                    res['22'] = '出售'
                    res['23'] = '购买'
                    type = res
                })
                const data = await getServiceDetail(id)
                title.info = data
                title.list = data.imgs ? data.imgs.split(',') : ''
                title.info.company = priceRes[data.company]
                title.info.type = type[data.type]
                title.info.msg = data.msg
            } else if (title.cn == '需求信息') {
                await getDDDomInfo()
                let type
                getDemandType().then(res => {
                    res['22'] = '出售'
                    res['23'] = '购买'
                    type = res
                })
                const data = await getDemandDetail(id)
                title.info = data
                title.list = data.imgs ? data.imgs.split(',') : ''
                // title.info.company = priceRes[data.company]
                // title.info.type = type[data.type]
                title.info.msg = data.msg
            }
            document.title = title.info.title
        }
        onMounted(() => {
            title.cn = route.query.name
            title.id = route.query.id
            initData(title.id)
        })
        return {
            title,
            priceRes,
            orderType,
            serviceType,
            TGForm,
            labelCol: {
                span: 6,
            },
            wrapperCol: {
                span: 16,
                offset: 2
            },
            onChange,
            initData
        }
    },
    components: {
        Header,
        pageTool
    }
}
</script>


<style scoped lang="stylus">
    .content {
        .page-content {
            padding 20px 15px
            background-color #FFF
            .page-img {
                width 100%
                overflow hidden
            }
            .page-img img {
                width 100%
            }
            .page-text-block {
                padding 15px 20px
                box-shadow 0 3px 6px rgba(0, 0, 0, 0.16)
            }
            .page-text-block >>> .ant-form-item {
                margin-bottom 0
            }
            .page-text {
                width 100%
                padding 10px 15px
                margin-top 10px
                overflow hidden
                color #575757
                font-size 14px
                .page-text-button {
                    margin-top 15px
                    width 100%
                    text-align center
                    .cus-button {
                        width 99px
                        background #03CA8F
                        border-radius 6px
                        border-color #03CA8F
                    }
                }
            }
            .page-text p:first-child {
                font-size 15px
                font-weight bolder
                height 30px
                border-bottom 1px solid #575757
                margin-bottom 5px
            }
            .page-title {
                color #575757
                font-weight bolder
                font-size 16px
                text-align center
                width 100%
                height 30px
                overflow hidden
            }
            .page-title span {
                display inline-block
                position relative
            }
            .page-title span::before {
                display block
                content ''
                width 80px
                height 2px
                background-color #8BC53F
                position absolute
                left -90px
                top 12px
            }
            .page-title span::after {
                display block
                content ''
                width 80px
                height 2px
                background-color #8BC53F
                position absolute
                right -90px
                top 12px
            }
        }
    }
    @media (max-width: 575px) {
        .page-text-block >>> .ant-form-item-label {
            line-height 10.667vw
        }
    }
</style>